/**
 * 判断是否是手机端
 * @returns {boolean}
 */
export default function isPhone() {
  const flag = /Phone.*OpenHarmony|harmonyos.*mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  return flag;
}
